//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Item from '@/components/business/consultant_medal_item'
export default {
    props: {
        items: Array
    },
    computed: {
        obtained () {
            return this.items.filter(({ obtained }) => obtained)
        },
        disabled () {
            return this.items.filter(({ obtained }) => !obtained)
        }
    },
    components: {
        Item
    }
}
